import { cn } from "@/lib/utils";
import { CaptionDto } from "@repo/api/caption";

const Filters = [
  {
    name: "All",
    value: "ALL",
  },
  {
    name: "Static",
    value: "STATIC",
  },
  {
    name: "Highlighted",
    value: "HIGHLIGHTED",
  },
  {
    name: "Single Word",
    value: "SINGLE_WORD",
  },
  {
    name: "Custom Presets",
    value: "CUSTOM_PRESETS",
  },
] as const;

export type Filters = (typeof Filters)[number]["value"];

export const getFilteredCaptions = (
  selectedFilter: Filters,
  presets: CaptionDto[],
  customPresets: CaptionDto[],
) => {
  switch (selectedFilter) {
    case "ALL":
      return presets;
    case "STATIC":
      return presets.filter((preset) => preset.config.displayMode === "STATIC");
    case "HIGHLIGHTED":
      return presets.filter(
        (preset) => preset.config.displayMode === "HIGHLIGHTED",
      );
    case "SINGLE_WORD":
      return presets.filter(
        (preset) => preset.config.displayMode === "SINGLE_WORD",
      );
    case "CUSTOM_PRESETS":
      return presets.filter((preset) =>
        customPresets.some((custom) => custom.externalId === preset.externalId),
      );
    default:
      return presets;
  }
};

function CaptionsFilters({
  selectedFilter,
  setSelectedFilter,
}: {
  selectedFilter: Filters;
  setSelectedFilter: (filter: Filters) => void;
}) {
  return (
    <div className="mb-4 flex w-full flex-row gap-2 pr-6">
      {Filters.map((filter) => (
        <button
          className={cn(
            "h-7 cursor-pointer rounded-sm px-3 text-xs font-medium whitespace-nowrap text-white",
            filter.value === selectedFilter
              ? "bg-tertiary-400"
              : "text-text-secondary",
          )}
          key={filter.value}
          onClick={() => setSelectedFilter(filter.value)}
        >
          {filter.name}
        </button>
      ))}
    </div>
  );
}

export default CaptionsFilters;
